import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

export const openOnboarding = (step = 0) => window.dispatchEvent(new CustomEvent("open-onboarding", { detail: { step } }));
export const openGuidedProperty = () => window.dispatchEvent(new CustomEvent("open-onboarding", { detail: { step: 1, fresh: true } }));

export const startDemo = async () => {
  const { default: api } = await import("../../lib/api");
  await api.post("/onboarding/demo");
  await api.put("/onboarding/wizard", { status: "dismissed" }).catch(() => {});
  window.location.assign("/app");
};

// F3 : au premier vrai bail, proposer la suppression de l'exemple.
export const maybeDropDemo = async () => {
  const { default: api } = await import("../../lib/api");
  const s = (await api.get("/onboarding/state").catch(() => ({ data: {} }))).data;
  if (s.has_example && s.has_lease && window.confirm("Votre premier vrai bail est créé. Supprimer le bien d'exemple et ses données fictives ?")) {
    await api.delete("/onboarding/demo").catch(() => {});
    window.dispatchEvent(new Event("onboarding-closed"));
  }
};

export const EmptyState = ({ icon: Icon = Sparkles, title, cta, onCta, demo, testid = "empty-state" }) => (
  <div className="relative overflow-hidden bg-white border border-brand-soft rounded-3xl px-6 py-12 sm:py-16 flex flex-col items-center text-center" data-testid={testid}>
    <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-brand-lime/15" aria-hidden />
    <div className="relative w-16 h-16 rounded-2xl bg-brand-softer grid place-items-center mb-5"><Icon className="w-8 h-8 text-brand-limeDark" /></div>
    <p className="relative max-w-md text-lg text-brand-greenDeep font-medium">{title}</p>
    {cta && (
      <button onClick={onCta} className="relative mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold transition-colors" data-testid={`${testid}-cta`}>
        {cta} <ArrowRight className="w-4 h-4" />
      </button>
    )}
    {demo && <button onClick={startDemo} className="relative mt-3 text-sm text-brand-green/60 hover:text-brand-greenDeep underline underline-offset-4" data-testid={`${testid}-demo`}>Voir un exemple</button>}
  </div>
);
